import { render, staticRenderFns } from "./InputSelectContractControl.global.vue?vue&type=template&id=1ace051e&lang=pug&"
import script from "./InputSelectContractControl.global.vue?vue&type=script&lang=ts&"
export * from "./InputSelectContractControl.global.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports